import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";

export type BillingsTaxiTaxiDetailsOrderForwardingActionContractTaxiDetails = {
  uuid: string;
  displayName: string;
};

export type BillingsTaxiTaxiDetailsOrderForwardingActionContract = {
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxi: BillingsTaxiTaxiDetailsOrderForwardingActionContractTaxiDetails;
  consumerTaxi: BillingsTaxiTaxiDetailsOrderForwardingActionContractTaxiDetails;
};

export type BillingsTaxiTaxiDetailsOrderForwardingActionTransportingOrderCargoOrder =
  {
    uuid: string;
    humanId: number;
  };

export type BillingsTaxiTaxiDetailsOrderForwardingActionTransportingOrder = {
  cargoOrder: BillingsTaxiTaxiDetailsOrderForwardingActionTransportingOrderCargoOrder;
};

export type BillingsTaxiTaxiDetailsOrderForwardingAction = {
  uuid: string;
  contract: BillingsTaxiTaxiDetailsOrderForwardingActionContract;
  transportingOrder: BillingsTaxiTaxiDetailsOrderForwardingActionTransportingOrder;
};

export type BillingsTaxiTaxiDetailsNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventUuid: string | null;
  plannedDate: Date | null;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  haltingAmount: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiTaxiDetailsContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsTaxiTaxiDetailsContributionBonusFavorableDistance = {
  type: BillingsTaxiTaxiDetailsContributionType.BONUS_FAVORABLE_DISTANCE;
  comment: string | null;
  distance: number;
  rate: number;
};

export type BillingsTaxiTaxiDetailsContributionBonusOther = {
  type: BillingsTaxiTaxiDetailsContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsContributionPenaltyWrongRoute = {
  type: BillingsTaxiTaxiDetailsContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsContributionPenaltyBeingLate = {
  type: BillingsTaxiTaxiDetailsContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsContributionPenaltyIncompatibleCar = {
  type: BillingsTaxiTaxiDetailsContributionType.PENALTY_INCOMPATIBLE_CAR;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsContributionPenaltyOther = {
  type: BillingsTaxiTaxiDetailsContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiTaxiDetailsContributionBonus =
  | BillingsTaxiTaxiDetailsContributionBonusFavorableDistance
  | BillingsTaxiTaxiDetailsContributionBonusOther;

export type BillingsTaxiTaxiDetailsContributionPenalty =
  | BillingsTaxiTaxiDetailsContributionPenaltyWrongRoute
  | BillingsTaxiTaxiDetailsContributionPenaltyBeingLate
  | BillingsTaxiTaxiDetailsContributionPenaltyIncompatibleCar
  | BillingsTaxiTaxiDetailsContributionPenaltyOther;

export type BillingsTaxiTaxiDetailsContribution =
  | BillingsTaxiTaxiDetailsContributionBonus
  | BillingsTaxiTaxiDetailsContributionPenalty;

type BillingsTaxiTaxiDetails = {
  orderForwardingAction: BillingsTaxiTaxiDetailsOrderForwardingAction;
  billingNodes: BillingsTaxiTaxiDetailsNode[];
  billingContributions: BillingsTaxiTaxiDetailsContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntryUuid: string;
  sumOfBonuses: number;
  sumOfPenalties: number;
  date: Date;
  status: BillingStatus;
  passengers: string[];
};

export default BillingsTaxiTaxiDetails;
